document.addEventListener('DOMContentLoaded', () => {
  const dropdown = document.querySelector('.faq-anchor-dropdown');

  dropdown.addEventListener('change', (e) => {
    const targetId = e.target.value;
    if (!targetId) return;

    const anchorEl = document.querySelector(`[href="${targetId}"]`);
    if (anchorEl) {
      anchorEl.click();
    }
  });

  const options = Array.from(dropdown.options)
    .map(opt => opt.value)
    .filter(Boolean);

  const sections = options
    .map(id => document.querySelector(id))
    .filter(Boolean);

  let headerClass = '.section-header';
  if (window.matchMedia('(max-width: 990px)').matches) {
    headerClass = '.faq-sticky-header-mobile';
  }

  const header = document.querySelector('.section-header');
  const faqHeader = document.querySelector('.faq-sticky-header-mobile');

  let offset = header.offsetHeight * -1;
  if (window.matchMedia('(max-width: 990px)').matches) {
    document.documentElement.style.setProperty('--scroll-margin-top', `${faqHeader.offsetHeight + 20}px`);
    offset = (faqHeader.offsetHeight * -1) - 21;
  }

  const intersectionWindowSize = 100;
  const bottomRoot = (window.innerHeight - intersectionWindowSize + offset) * -1;

  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        const id = '#' + entry.target.id;
        dropdown.value = id;

        const currentAnchor = document.querySelector(`[href="${id}"]`);
        document.querySelector(`.current-faq-anchor`).classList.remove('current-faq-anchor');
        currentAnchor.classList.add('current-faq-anchor');
      }
    });
  }, {
    rootMargin: `${offset}px 0px ${bottomRoot}px 0px`,
    threshold: 0
  });

  sections.forEach(section => observer.observe(section));
});